import { useEffect } from 'react';
import { connect } from 'redux-bundler-react';
import StepHeader from '@components/step-header/StepHeader';
import { Accordion } from '@trussworks/react-uswds';
import { recommendedInfoAccordion } from './PreAppForm3InstructionsHelper';
import LinkButton from '@components/link/linkButton';
import { FileTypes, ResourceFiles } from '@src/utils/enums';
import { useRequest } from '@stores';

export const PreAppForm3InstructionsMetadata = {
  header: 'Pre-application/Project Scoping Request Form',
  sectionName: 'Instructions',
};

const PreAppForm3Instructions = connect('doDownloadFile', ({ doDownloadFile, stepNo }) => {
  const updateSection = useRequest((state) => state.updateSection);

  useEffect(() => {
    updateSection(stepNo, { valid: true, label: PreAppForm3InstructionsMetadata.sectionName });
  }, [updateSection, stepNo]);

  return (
    <>
      <StepHeader text='Instructions' />
      <p>
        The <span className='text-bold'>pre-application meeting and scoping request</span> provides an electronic option
        for applicants to request a pre-application meeting with the U.S. Army Corps of Engineers (USACE) or to submit
        project scoping letters. This electronic application will guide you through providing the information required
        for a complete request.
      </p>
      <p className='margin-bottom-2'>
        <span className='text-bold'>Scoping letters,</span> which are typically submitted by applicants using Federal or
        State funding to accomplish a project of which they are the proponent, seek comment from the USACE regarding
        potential impacts to waters of the United States during very early phases of project development. These are
        typically submitted to help meeting requirements of the National Environmental Policy Act or similar state/local
        laws.
      </p>
      <p>
        <span className='text-bold'>Preapplication meetings</span> are typically held prior to an applicant submitting a
        project application and are normally reserved for{' '}
        <b>larger and more complex projects that require a standard individual permit</b>. The purpose of these meetings
        is to discuss various aspects of the project, such as the required permit type, estimated permit timeframes,
        potential complexities related to permitting (such as endangered species, historic properties, section 408,
        etc.), onsite and offsite alternatives, options for avoidance and minimization, potential construction layouts,
        compensatory mitigation options, and other information. The meetings usually involve the applicant, USACE staff,
        interested resource agencies (federal, state, or local), and sometimes the interested public.
      </p>
      <p className='margin-bottom-2'>
        Note - If a field site visit is requested, it will be necessary for the property owner to provide a Right of
        Entry Form and their designated agent (if one was retained) to provide a completed Agent Authorization Form.
      </p>
      <p className='margin-bottom-2 text-bold'>
        Recommended Information for Standard Permit Pre-application Meetings (click to expand each section to learn
        more):
      </p>
      <div className='container margin-bottom-2'>
        <Accordion bordered items={recommendedInfoAccordion} multiselectable={true} />
      </div>
      <div className='margin-top-2'>
        <LinkButton
          onClick={() => doDownloadFile(ResourceFiles.Reg101FreqUsedTerms, FileTypes.Resource)}
          title='RRS Commonly Used Regulatory Terms [PDF, 9 pages]'
          content='RRS Commonly Used Regulatory Terms [PDF, 9 pages]'
        />
      </div>
    </>
  );
});

PreAppForm3Instructions.metadata = PreAppForm3InstructionsMetadata;

export default PreAppForm3Instructions;
